"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var language = _ref.language;
  return language;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJsYW5ndWFnZSJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvbGFuZ3VhZ2UudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBSZWR1eFN0YXRlIH0gZnJvbSAnLi4vdHlwZXMvaW50ZXJuYWwvUmVkdXhTdGF0ZSc7XG5cbmV4cG9ydCBkZWZhdWx0ICh7IGxhbmd1YWdlIH06IFJlZHV4U3RhdGUpOiBzdHJpbmcgPT4gbGFuZ3VhZ2U7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7ZUFFZTtFQUFBLElBQUdBLFFBQUgsUUFBR0EsUUFBSDtFQUFBLE9BQXNDQSxRQUF0QztBQUFBLEMifQ==